import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import type { ChecklistStatus } from '../../shared/checklistUtils';
import type { TaxesPaymentsField } from '../../tabs/taxesPayments/types';

interface TaxesPaymentsRuleText {
  field: TaxesPaymentsField;
  rule: string;
  summary: Record<ChecklistStatus, string>;
}

export const TAXES_PAYMENTS_RULE_TEXT: Record<CmChecklist.TaxesPaymentsRuleId, TaxesPaymentsRuleText> = {
  'city-tax-payable-direct': {
    field: 'City/Other Tax Payable Direct',
    rule: 'If City/Other Tax Payable Direct is marked Yes, the tax details field must be populated before approval.',
    summary: {
      approved: 'City/Other Tax Payable Direct details are complete.',
      blocked: 'Opportunity data is unavailable to verify this rule.',
      'requires approval': 'City/Other Tax Payable Direct needs tax detail comments before approval.',
    },
  },
  'per-room-city-taxes': {
    field: 'Per-room city taxes in Admin Portal',
    rule: 'If per-room city taxes are payable directly to the property, they must be loaded in the Admin Portal before the offer goes live.',
    summary: {
      approved: 'Per-room city taxes are correctly reflected in the Admin Portal.',
      blocked: 'Opportunity or property data is unavailable to verify this rule.',
      'requires approval': 'Per-room city taxes need to be loaded in the Admin Portal.',
    },
  },
  'payment-mechanism-milestone': {
    field: 'Payment mechanism and milestone rules',
    rule: 'Both payment method and milestone rules must be populated, and milestone percentages must sum to 100%.',
    summary: {
      approved: 'Payment method and milestone rules are complete and sum to 100%.',
      blocked: 'Opportunity data is unavailable to verify this rule.',
      'requires approval': 'Payment method and milestone rules need review.',
    },
  },
  'prize-used': {
    field: 'Prize (Educational Package)',
    rule: "If the Policy Bible's Educational Package Clause is Enabled for the hotel's chain and geo, Salesforce must show an Educational Package (prize) granted.",
    summary: {
      approved: 'Salesforce Educational Package status matches the Policy Bible.',
      blocked: 'Opportunity data is unavailable to verify this rule.',
      'requires approval': 'Educational Package (prize) needs review against the Policy Bible.',
    },
  },
};

// Reason-specific summaries take precedence over the status summary.
export const TAXES_PAYMENTS_REASON_SUMMARY: Partial<Record<CmChecklist.TaxesPaymentsReasonCode, string>> = {
  policy_bible_rule_missing: "No Policy Bible entry matched this offer's chain and geo.",
  educational_package_status_missing: 'Salesforce Educational Package status is blank.',
  educational_package_not_granted:
    'The Policy Bible includes an Educational Package (prize) for this chain and geo, but Salesforce shows none granted.',
};
